export default __webpack_public_path__ + "static/media/beavers-and-leader.8c820548.jpg";